const countResources = () => {
    const allResources = document.querySelectorAll('.treatment-section:not([hidden]) .cols__text');
    document.querySelector('.treatment-counter span').textContent = allResources.length;
};

export default () => {
    countResources();
    document.querySelector('#categoryTreatment').addEventListener('change', (e) => {
        const categoryTreatment = e.target.value;
        const treatments = document.querySelectorAll('.treatment-section');
        treatments.forEach((treatment) => {
            if (categoryTreatment === 'all' || treatment.id === categoryTreatment) {
                treatment.removeAttribute('hidden');
            } else {
                treatment.setAttribute('hidden', 'true');
            }
        });
        countResources();
    });

    const filters = document.querySelectorAll('.filter');

    filters.forEach((filter) => {
        filter.addEventListener('click', (event) => {
            event.stopPropagation(); // Stop propagation to prevent body click event from triggering immediately
            filter.classList.toggle('active');
            const arrow = filter.querySelector('.arrow');
            if (filter.classList.contains('active')) {
                arrow.classList.add('up');
            } else {
                arrow.classList.remove('up');
            }
        });
    });

    // Clicking outside to collapse
    document.body.addEventListener('click', (e) => {
        filters.forEach((filter) => {
            if (!filter.contains(e.target)) {
                filter.classList.remove('active');
                const arrow = filter.querySelector('.arrow');
                arrow.classList.remove('up');
            }
        });
    });
};
